export default __webpack_public_path__ + "static/media/Group289.08239749.png";